import clsx from "clsx";
import { useEffect, useState } from "react";

const ImageSkeleton = ({ src, srcSet = "", sizes = "", loading, custCls, custH = "", custW = "", custStyle = "", alt = "", isDarker = false, isBarcode = false, id = "", hasEvent = false, isDiffSkeletonSize = false, isWFull = true, noShimmer = false, scaleUpImg = () => { } }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const props = {
    src,
    width: "100",
    className: custH ? custCls + " " + custH : custCls,
    loading: loading ? loading : "lazy",
  }
  if (id) {
    props.id = id;
  }
  if (alt) {
    props.alt = alt;
  }
  if (srcSet) {
    props.srcSet = srcSet;
  }
  if (srcSet) {
    props.sizes = sizes;
  }

  useEffect(() => {
    if (isLoaded) setIsLoaded(false);
    if (!src) return;

    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsLoaded(true);
    };

    img.onerror = () => {
      console.log("Failed load image!");
      setIsLoaded(true);
    };
  }, [src]);

  useEffect(() => {
    if (isLoaded) setIsLoaded(false);
    if (!src) return;

    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsLoaded(true);
    };

    img.onerror = () => {
      console.log("Failed load image!");
      setIsLoaded(true);
    };
  }, [custCls]);

  const handleScaleUpImg = () => {
    scaleUpImg(id)
  }

  // return (
  return !isLoaded ? (
    <>
      {!noShimmer &&
        <div className={clsx("animate-shimmer transition-opacity", { "bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200": isDarker, "h-full": !custH && !isDiffSkeletonSize, "w-full": !isBarcode && isWFull }, custH, custW, custStyle)}></div>
      }
    </>
  ) : (
    hasEvent ?
      <img {...props} onClick={handleScaleUpImg} />
      :
      <img {...props} />
  );
};

export default ImageSkeleton